module.exports = __webpack_public_path__ + "static/img/08shenme.2614b2c3.gif";